/* eslint-disable react-hooks/exhaustive-deps */
import { DocumentSignerStatus } from "@interfaces/response";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

export type buttonStatus = "validado" | "completo" | "editar" | "llenar";

export interface buttonProps {
  buttonLabel: string;
  backgroundColor: string;
  color?: string;
}

export interface ButtonFirmaProps {
  status?: DocumentSignerStatus;
  onClick: () => void;
}

const ButtonFirma: React.FC<ButtonFirmaProps> = ({ status, onClick }) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const [btnParams, setBtnParams] = useState<buttonProps>({
    buttonLabel: "Firmar",
    backgroundColor: theme?.palette?.primary?.main,
    color: "#FFFFFF",
  });

  const clickHandle = () => {
    if (status === "confirmed") {
      return;
    }
    onClick();
  };

  const generateButtonParams = () => {
    let btnParams: buttonProps = {
      buttonLabel: "Firmar",
      backgroundColor: theme?.palette?.primary?.main,
      color: "#FFFFFF",
    };

    if (status === "confirmed") {
      btnParams = {
        buttonLabel: "Firmado",
        backgroundColor: theme?.palette?.primary?.dark,
        color: theme?.palette?.primary?.light,
      };
    }

    setBtnParams(btnParams);
  };

  useEffect(() => {
    generateButtonParams();
  }, [status]);

  return (
    <Button
      variant="default"
      type="submit"
      disabled={status === "confirmed"}
      sx={{
        padding: "12px",
        width: isMobileOrTablet ? "200px" : "200px",
        textTransform: "none",
        height: isMobileOrTablet ? "30px" : "40px",
        backgroundColor: btnParams.backgroundColor,
        color: btnParams.color,
        "&:hover": {
          backgroundColor: btnParams.backgroundColor,
        },
        "&.Mui-disabled": {
          backgroundColor: btnParams.backgroundColor,
          color: btnParams.color,
          opacity: 1,
        },
      }}
      onClick={clickHandle}
    >
      {btnParams.buttonLabel}
    </Button>
  );
};

export default ButtonFirma;
